import Cookies from 'js-cookie'
import Link from 'next/link'
import packagejson from 'package.json'
import { useEffect, useState } from 'react'
import { FaTimes } from 'react-icons/fa'
import { HiSparkles } from 'react-icons/hi2'
import AppUpdateBinder from './AppUpdateBinder'

const currentVersion = packagejson.version
const previousVersion = '1.16.0'

const VersionBanner = () => {
  const [showBanner, setShowBanner] = useState(false)

  useEffect(() => {
    const versionCookie = Cookies.get(currentVersion)
    const lastVersionViewed = Cookies.get(previousVersion)

    // Check if today is first visit
    const lastVisit = localStorage.getItem('lastVisit')
    const isTodayFirstVisit = !lastVisit || lastVisit === new Date().toLocaleDateString()

    // Show banner if: user hasn't seen this version, it's not their first day, and they saw the previous version
    if (!versionCookie && !isTodayFirstVisit && lastVersionViewed) {
      setShowBanner(true)
    }

    Cookies.set(currentVersion, '1', { expires: 300 })
    if (!lastVisit) {
      localStorage.setItem('lastVisit', new Date().toLocaleDateString())
    }
  }, [])

  const handleDismiss = () => {
    setShowBanner(false)
    Cookies.set(currentVersion, '1', { expires: 75 })
  }

  return (
    <>
      <AppUpdateBinder />
      {showBanner && (
        <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:max-w-sm z-50 animate-slide-up">
          <div className="bg-slate-900 dark:bg-slate-800 border border-slate-700 px-4 py-3 rounded-xl shadow-2xl">
            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-8 h-8 rounded-full bg-emerald-500/20">
                <HiSparkles className="text-emerald-400 text-lg" />
              </div>
              <div className="flex-1">
                <p className="text-white text-sm font-medium">
                  <span className="font-bold text-emerald-400">v{currentVersion}</span>{' '}
                  <span className="text-slate-300">yayınlandı!</span>
                </p>
              </div>
              <Link
                href="/versiyonlar"
                className="bg-emerald-500 hover:bg-emerald-400 text-white text-xs font-semibold px-3 py-1.5 rounded-full transition-colors whitespace-nowrap"
                onClick={handleDismiss}
              >
                Gör
              </Link>
              <button
                onClick={handleDismiss}
                className="text-slate-400 hover:text-white p-1 transition-colors"
                aria-label="Kapat"
              >
                <FaTimes className="text-sm" />
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default VersionBanner
